var _style, _path, _g, _defs, _clipPath, _linearGradient, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Camada_1",
    x: 0,
    y: 0,
    viewBox: "0 0 116.6 29",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29 25.2c0 2.1-1.7 3.8-3.8 3.8H3.8C1.7 29 0 27.3 0 25.2V3.8C0 1.7 1.7 0 3.8 0h21.4C27.3 0 29 1.7 29 3.8v21.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.5,
    y1: 780.991,
    x2: 19.5,
    y2: 771.026,
    gradientTransform: "matrix(1 0 0 -1 0 795.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b44f6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M24.5 24.4h-10l10-9.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.141,
    y1: 785.736,
    x2: 19.791,
    y2: 765.805,
    gradientTransform: "matrix(1 0 0 -1 0 795.446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#9b44f6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M24.5 24.4H4.6V4.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M24.5 24.5h-10l10-9.9z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -568.157,
    y1: 619.699,
    x2: -565.764,
    y2: 617.307,
    gradientTransform: "matrix(.8685 1.214 .8089 -.5787 14.082 1067.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    clipPath: "url(#SVGID_4_)",
    fill: "url(#SVGID_5_)",
    d: "M24.5 24.5l-5-5 .9-.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "brand_name_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.5 4.8h3.2v19.5h-3.2V4.8zm20.4 13.3H66c.2 1 .7 1.8 1.5 2.4.8.6 1.8.9 3 .9 1.5 0 2.8-.5 3.8-1.5l1.9 1.9c-.6.7-1.5 1.4-2.5 1.8-1 .4-2 .6-3.2.6-1.5 0-2.9-.3-4-.9-1.2-.6-2.1-1.5-2.7-2.5-.6-1.1-.9-2.3-.9-3.7 0-1.4.3-2.6.9-3.6.6-1.1 1.5-1.9 2.6-2.5 1.1-.6 2.3-.9 3.7-.9 1.4 0 2.6.3 3.6.9 1.1.6 1.9 1.4 2.5 2.5.6 1.1.9 2.3.9 3.8-.2.1-.2.4-.2.8zm-9.6-4.6c-.7.6-1.2 1.5-1.3 2.5h7.9c-.1-1-.6-1.8-1.3-2.4-.7-.6-1.6-.9-2.6-.9-1.1-.1-2 .2-2.7.8zm38.8 4.6H95.2c.2 1 .7 1.8 1.5 2.4.8.6 1.8.9 3 .9 1.5 0 2.8-.5 3.8-1.5l1.9 1.9c-.6.7-1.5 1.4-2.5 1.8-1 .4-2 .6-3.2.6-1.5 0-2.9-.3-4-.9-1.2-.6-2.1-1.5-2.7-2.5-.6-1.1-.9-2.3-.9-3.7 0-1.4.3-2.6.9-3.6s1.5-1.9 2.6-2.5c1.1-.6 2.3-.9 3.7-.9 1.4 0 2.6.3 3.6.9 1.1.6 1.9 1.4 2.5 2.5.6 1.1.9 2.3.9 3.8-.2.1-.2.4-.2.8zm-9.6-4.6c-.7.6-1.2 1.4-1.3 2.5h7.9c-.1-1-.6-1.8-1.3-2.4-.7-.6-1.6-.9-2.6-.9-1.1-.1-2 .2-2.7.8zM92.1 10L86 24.2h-3.2L76.6 10H80l4.5 10.4L89 10h3.1zm-42.3 0h4L45 18.9l-2-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43 16.8l2-2 9.4 9.4h-4L43 16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2 4.8h3.2v19.5h-3.2zm76.4 5.2v3.1c-.3-.1-.5-.1-.8-.1-1.3 0-2.3.4-3 1.1-.7.7-1.1 1.8-1.1 3.2v6.8h-3.3V10h3.2v2.2c.9-1.5 2.6-2.2 5-2.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e508030155275995c5f38fe7de486727.svg";
export { ForwardRef as ReactComponent };